/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from "./actionTypes";

const axiosPayLoad = {
  labelerList: [],
  errorPopupMessage: null,
  searchByDrugNameTableData: [],
};


const reducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_RCA_LABELER_LIST:
      return { ...state, labelerList: action.labelerList };
    case actionTypes.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA:
      return { ...state, searchByDrugNameTableData: action.payload };
    case actionTypes.NDC_DETAILS_TABLE_DATA:
      return { ...state, ndcDetailsTableData: action.payload };
    case actionTypes.NDC_DETAILS_TABLE_ROW_SELECTED:
      return { ...state, ndcDetailsTableRowSelected: action.payload };
    case actionTypes.GET_COMMON_DROPDOWN_DATA:
      return { ...state, dropdown: action.dropdown };
    case actionTypes.NDC_ERROR_POPUP_MESSAGE:
      return { ...state, errorPopupMessage: action.payload };
    case actionTypes.GET_UC_NDC_BY_LABELLER:
      return { ...state, ndcListFromLabeller: action.ndcListFromLabeller };
    case actionTypes.ADD_REQUESTCLAIM_AUDIT:
      return { ...state, addRequestClaim: action.payload };
    case actionTypes.REQUESTCLAIM_INPUT_VALUES:
      return { ...state, getRequestFieldsValue: action.payload };
    case actionTypes.LEFT_SIDE_TABLEDETAILS:
      return { ...state, leftNdcTable: action.payload };
    case actionTypes.RIGHT_SIDE_TABLEDETAILS:
      return { ...state, rightNdcTable: action.payload };
    case actionTypes.REQUESTCLAIM_ERRORS:
      return { ...state, getRequestFieldsErrors: action.payload };
    case actionTypes.DUPLICATE_ERRORS:
      return { ...state, duplicateErrors: action.payload };
    case actionTypes.CLEAR_PRELOADED_DATA:
      return [];
    default: return state;
  }
};

export default reducer;